import { ChevronRight, CircleChevronRight, CircleHelp } from "lucide-react";
import { Link } from "react-router-dom";

const ANSWER_ACTION_LABELS = new Set([
  "check",
  "check answer",
  "click to continue",
  "continue",
  "retry",
  "try again",
]);

const CustomButton = ({
  text,
  onClick,
  isShaking,
  type,
  disabled,
  isIcon = "true",
}) => {
  const isAnswerAction = ANSWER_ACTION_LABELS.has(
    String(text || "").trim().toLowerCase(),
  );

  const getButtonStyles = () => {
    switch (type) {
      case "correct":
        return "bg-[#A6FF57] text-black border-4 border-[#71B832] shadow-[0_4px_10px_rgba(0,0,0,0.4),_inset_3px_3px_6px_rgba(255,255,255,0.5)] hover:bg-[#98E84D]";

      case "incorrect":
        return "bg-[#FFCDD2] text-black border-4 border-[#C62828] shadow-[0_4px_10px_rgba(0,0,0,0.4),_inset_3px_3px_6px_rgba(255,255,255,0.5)] hover:bg-[#E57373]";

      case "selected":
        return "bg-[#6F6F6F] text-white border-4 border-[#464646] shadow-[0_4px_10px_rgba(0,0,0,0.4),_inset_3px_3px_6px_rgba(255,255,255,0.5)] hover:bg-[#5E5E5E]";

      default:
        return "bg-gray-600 text-gray-400 border-4 border-gray-500 cursor-not-allowed opacity-50 shadow-[0_4px_10px_rgba(0,0,0,0.4),_inset_3px_3px_6px_rgba(255,255,255,0.2)]";
    }
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      data-md-answer-action={isAnswerAction ? "true" : undefined}
      className={`flex font-mali items-center justify-center gap-3 px-4 py-3 max-h-16 w-72 rounded-full transition-all duration-300 text-2xl font-bold 
        ${getButtonStyles()} 
        ${isShaking ? "animate-shake" : ""}`}
      // Fixed width of 192px (w-48) to maintain consistent button size regardless of text length
    >
      {text} {isIcon && <CircleChevronRight size={28} />}
    </button>
  );
};

export default CustomButton;

export const DetailsButton = ({ name = "Home", goTo = "yearsdashboard" }) => {
  return (
    <Link className="settings-details-button flex gap-4" to={`/${goTo}`}>
      <CircleHelp />
      <p className="font-bold">{name}</p>
      <ChevronRight />
    </Link>
  );
};
